import { render, staticRenderFns } from "./DeadPipelineDesktop.vue?vue&type=template&id=f09787b2&"
import script from "./DeadPipelineDesktop.vue?vue&type=script&lang=js&"
export * from "./DeadPipelineDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports